import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Heart, Loader2 } from "lucide-react";
import { usersAPI } from "../api";
import { useLang } from "../context/LangContext";

const FavoritesPage: React.FC = () => {
  const navigate = useNavigate();
  const { lang } = useLang();
  const [favorites, setFavorites] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    usersAPI
      .getFavorites()
      .then((r) => {
        const d = r.data || {};
        const list = Array.isArray(d) ? d : (d.data ?? []);
        setFavorites(Array.isArray(list) ? list : []);
      })
      .catch(() => setFavorites([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ minHeight: "100vh", background: "var(--bg)" }}>
      {/* Fixed Header */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 100,
          background: "rgba(10,14,26,.95)",
          backdropFilter: "blur(12px)",
          borderBottom: "1px solid var(--border)",
          height: 52,
        }}>
        <div
          style={{
            maxWidth: 520,
            margin: "0 auto",
            padding: "0 16px",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <button
              onClick={() => navigate("/dashboard")}
              style={{
                background: "transparent",
                border: "none",
                color: "var(--muted)",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: 6,
                fontSize: 13,
                fontWeight: 600,
              }}>
              <ArrowLeft size={16} /> Orqaga
            </button>
            <span style={{ color: "#fff", fontWeight: 700, fontSize: 15 }}>
              Saqlangan testlar
            </span>
          </div>
        </div>
      </div>

      <div
        style={{ maxWidth: 520, margin: "0 auto", padding: "68px 16px 32px" }}>
        {loading ?
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              paddingTop: 100,
            }}>
            <Loader2 className="animate-spin text-blue-500" size={32} />
          </div>
        : favorites.length === 0 ?
          <div
            className="fade-up"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              paddingTop: 80,
              textAlign: "center",
              gap: 20,
            }}>
            <div
              style={{
                width: 80,
                height: 80,
                borderRadius: 24,
                background: "rgba(59, 130, 246, 0.1)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}>
              <Heart size={32} style={{ color: "#3B82F6" }} />
            </div>
            <div>
              <p
                style={{
                  color: "#fff",
                  fontWeight: 800,
                  fontSize: 18,
                  marginBottom: 8,
                }}>
                Saqlangan testlar yo'q
              </p>
              <p
                style={{
                  color: "var(--muted)",
                  fontSize: 14,
                  lineHeight: 1.5,
                  maxWidth: 280,
                }}>
                Testlarni yechayotganda, ❤️ bosib savolingizni saqlang
              </p>
            </div>
            <button
              onClick={() => navigate("/dashboard")}
              style={{
                marginTop: 10,
                padding: "12px 24px",
                borderRadius: 12,
                background: "var(--card)",
                border: "1px solid var(--border)",
                color: "#fff",
                fontWeight: 700,
                fontSize: 14,
                cursor: "pointer",
              }}>
              Asosiy sahifaga qaytish
            </button>
          </div>
        : <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 10,
                padding: "0 4px",
              }}>
              <p
                style={{
                  color: "var(--muted)",
                  fontSize: 12,
                  fontWeight: 600,
                }}>
                JAMI:{" "}
                <span style={{ color: "#3B82F6", fontWeight: 800 }}>
                  {favorites.length} TA SAVOL
                </span>
              </p>
            </div>

            {favorites.map((q, i) => (
              <div
                key={q.questionId ?? i}
                className="fade-up"
                style={{
                  animationDelay: `${i * 30}ms`,
                  background: "var(--card)",
                  border: "1px solid rgba(59, 130, 246, 0.15)",
                  borderRadius: 16,
                  padding: "16px",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                }}>
                <div
                  style={{
                    display: "flex",
                    gap: 12,
                    alignItems: "flex-start",
                  }}>
                  <div
                    style={{
                      width: 24,
                      height: 24,
                      borderRadius: 8,
                      background: "rgba(59, 130, 246, 0.1)",
                      color: "#3B82F6",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 10,
                      fontWeight: 800,
                      flexShrink: 0,
                      marginTop: 2,
                    }}>
                    {i + 1}
                  </div>
                  <p
                    style={{
                      color: "#E2E8F0",
                      fontSize: 14,
                      lineHeight: 1.5,
                      fontWeight: 500,
                    }}>
                    {q[`question_${lang}`] ||
                      q.question_oz ||
                      q.text ||
                      q.question}
                  </p>
                </div>

                {q.photo_url && (
                  <img
                    src={q.photo_url}
                    alt=""
                    style={{
                      width: "100%",
                      borderRadius: 12,
                      marginTop: 12,
                      border: "1px solid var(--border)",
                    }}
                  />
                )}
              </div>
            ))}
          </div>
        }
      </div>
    </div>
  );
};

export default FavoritesPage;
